var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7188 3C6.90386 3 3 6.90526 3 11.7188C3 16.5351 6.90386 20.4375 11.7188 20.4375C16.5336 20.4375 20.4375 16.5351 20.4375 11.7188C20.4375 6.90526 16.5336 3 11.7188 3ZM11.7188 6.86719C12.5342 6.86719 13.1953 7.52827 13.1953 8.34375C13.1953 9.15923 12.5342 9.82031 11.7188 9.82031C10.9033 9.82031 10.2422 9.15923 10.2422 8.34375C10.2422 7.52827 10.9033 6.86719 11.7188 6.86719ZM13.6875 15.7969C13.6875 16.0299 13.4986 16.2188 13.2656 16.2188H10.1719C9.93889 16.2188 9.75 16.0299 9.75 15.7969V14.9531C9.75 14.7201 9.93889 14.5312 10.1719 14.5312H10.5938V12.2812H10.1719C9.93889 12.2812 9.75 12.0924 9.75 11.8594V11.0156C9.75 10.7826 9.93889 10.5938 10.1719 10.5938H12.4219C12.6549 10.5938 12.8438 10.7826 12.8438 11.0156V14.5312H13.2656C13.4986 14.5312 13.6875 14.7201 13.6875 14.9531V15.7969Z",
    fill: "#333333"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.5f89a4e5c13a5dbe93ee6b04c207cdff.svg";
export { ForwardRef as ReactComponent };